var Suites = {};

export default Suites = {
  "traditional towns": {
    "data": [{
        "name": "th-1",
        "sub-category": "",
        "sqft": {
          "": 2108
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 2
        },
        "image": {
          display: "/floorplans/display/th-1.jpg",
          position: "/floorplans/display/th-1 position.jpg",
          elevation: "/floorplans/display/th-1 elevation.jpg"
          
        },

        "floorplans": {
          "main": "/floorplans/layout/th-1-main.svg",
          "ground": '/floorplans/layout/th-1-ground.svg',
          "third": "/floorplans/layout/th-1-third.svg",
          "basement": "/floorplans/layout/th-1-basement.svg"
        },
      },
      {
        "name": "th-2",
        "sub-category": "",
        "sqft": {
          "": 2265,
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 2
        },
        "image": {
          display: "/floorplans/display/th-2.jpg",
          position: "/floorplans/display/th-2 position.jpg",
          elevation: "/floorplans/display/th-2 elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/th-2-main.svg",
          "ground": '/floorplans/layout/th-2-ground.svg',
          "third": "/floorplans/layout/th-2-third.svg",
          "basement": "/floorplans/layout/th-2-basement.svg"
        },
      },
   
      {
        "name": "th-3 end",
        "sub-category": "",
        "sqft": {
          "": 2344
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 2
        },
        "image": {
          display: "/floorplans/display/th-3 end.jpg",
          position: "/floorplans/display/th-3 position.jpg",
          elevation: "/floorplans/display/th-3 elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/th-3-main.svg",
          "ground": '/floorplans/layout/th-3-ground.svg',
          "third": "/floorplans/layout/th-3-third.svg",
          "thirdoptional": "/floorplans/layout/th-3-third-optional.svg",
          "basement": "/floorplans/layout/th-3-basement.svg"
        },
      },

      {
        "name": "th-3 end",
        "sub-category": "upgrade A",
        "greyedOut": true,
        "sqft": {
          "": 2518
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 2
        },
        "image": {
          display: "/floorplans/display/th-3 end-upgrade.jpg",
          position: "/floorplans/display/th-3-upgrade position.jpg",
          elevation: "/floorplans/display/th-3-upgrade elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/th-3-end-main.svg",
          "ground": '/floorplans/layout/th-3-end-ground.svg',
          "third": "/floorplans/layout/th-3-end-third.svg",
          "thirdoptional": "/floorplans/layout/th-3-end-third-optional.svg",
          "basement": "/floorplans/layout/th-3-end-basement.svg"
        },
      },
      {
        "name": "th-3 end",
        "sub-category": "upgrade B",
        "sqft": {
          "": 2498
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 2
        },
        "image": {
          display: "/floorplans/display/th-3 end upgrade b.jpg",
          position: "/floorplans/display/th-3-upgrade position.jpg",
          elevation: "/floorplans/display/th-3-end-upgrade-b-elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/th-3-end-b-main.svg",
          "ground": '/floorplans/layout/th-3-end-b-ground.svg',
          "third": "/floorplans/layout/th-3-end-b-third.svg",
          "thirdoptional": "/floorplans/layout/th-3-end-b-third-optional.svg",
          "basement": "/floorplans/layout/th-3-end-b-basement.svg"
        },
      },

      {
        "name": "th-4",
        "sub-category": "corner",
        "sqft": {
          "": 2944
        },
        "rooms": {
          "bed": 4,
          "bath": 3,
          "powder room": 1
        },
        "image": {
          display: "/floorplans/display/th-4.jpg",
          position: "/floorplans/display/th-4 position.jpg",
          elevation: "/floorplans/display/th-4 elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/th-4-main.svg",
          "ground": '/floorplans/layout/th-4-ground.svg',
          "second": "/floorplans/layout/th-4-second.svg",
          "third": "/floorplans/layout/th-4-basement.svg"
        },
      },

      {
        "name": "th-5",
        "sub-category": "",
        "sqft": {
          "": 2782
        },
        "rooms": {
          "bed": 4,
          "bath": 3,
          "powder room": 2
        },
        "image": {
          display: "/floorplans/display/th-5.jpg",
          position: "/floorplans/display/th-5 position.jpg",
          elevation: "/floorplans/display/th-5 elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/th-5-main.svg",
          "ground": '/floorplans/layout/th-5-ground.svg',
          "second": "/floorplans/layout/th-5-third.svg",
          "third": "/floorplans/layout/th-5-basement.svg"
        },
      },

    ]
  },
  /**Urban Towns */
  "urban towns": {
    "data": [{
        "name": "ut-1",
        "sub-category": "",
        "sqft": {
          "": 1408
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 1
        },
        "image": {
          display: "/floorplans/display/ut-1.jpg",
          position: "/floorplans/display/ut-1 position.jpg",
          elevation: "/floorplans/display/ut-1 elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/ut-1-main.svg",
          "ground": '/floorplans/layout/ut-1-ground.svg',
          "third": "/floorplans/layout/ut-1-third.svg",
          "basement": "/floorplans/layout/ut-1-basement.svg"
        },
      },

      {
        "name": "ut-2",
        "sub-category": "",
        "sqft": {
          "": 1589
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 1
        },
        "image": {
          display: "/floorplans/display/ut-2.jpg",
          position: "/floorplans/display/ut-2 position.jpg",
          elevation: "/floorplans/display/ut-2 elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/ut-2-main.svg",
          "ground": '/floorplans/layout/ut-2-ground.svg',
          "third": "/floorplans/layout/ut-2-2nd.svg",
          "basement": "/floorplans/layout/ut-2-basement.svg"
        },
      },

      {
        "name": "ut-3 end",
        "sub-category": "",
        "greyedOut": true,
        "sqft": {
          "": 1783
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 1
        },
        "image": {
          display: "/floorplans/display/ut-3 end upgrade.jpg",
          position: "/floorplans/display/ut-3 position.jpg",
          elevation: "/floorplans/display/ut-3-upgrade elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/ut-3-main.svg",
          "ground": '/floorplans/layout/ut-3-ground.svg',
          "third": "/floorplans/layout/ut-3-2nd.svg",
          "basement": "/floorplans/layout/ut-3-basement.svg"
        },
      },
      {
        "name": "ut-3 end",
        "sub-category": "upgrade",
        "greyedOut": true,
        "sqft": {
          "": 1783
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 1
        },
        "image": {
          display: "/floorplans/display/ut-3 end upgrade.jpg",
          position: "/floorplans/display/ut-3-upgrade position.jpg",
          elevation: "/floorplans/display/ut-3-upgrade elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/ut-3-upgrade-main.svg",
          "ground": '/floorplans/layout/ut-3-upgrade-ground.svg',
          "third": "/floorplans/layout/ut-3-upgrade-third.svg",
          "basement": "/floorplans/layout/ut-3-upgrade-basement.svg"
        },
      },
      {
        "name": "ut-4",
        "sub-category": "corner",
        "sqft": {
          "": 1778
        },
        "rooms": {
          "bed": 3,
          "bath": 2,
          "powder room": 1
        },
        "image": {
          display: "/floorplans/display/ut-4.jpg",
          position: "/floorplans/display/ut-4 position.jpg",
          elevation: "/floorplans/display/ut-4 elevation.jpg"
        },
        "floorplans": {
          "main": "/floorplans/layout/ut-4-main.svg",
          "ground": '/floorplans/layout/ut-4-ground.svg',
          "second": "/floorplans/layout/ut-4-2nd.svg",
          "basement": "/floorplans/layout/ut-4-basement.svg"
        },
      },
      
    ]
  }

}; //Suites